import WbHttpClient from './wbhttpclient';

export default class EmojiServices {
    constructor() {
        this.WbHttpClient = new WbHttpClient();
    }

    /**
     * get org emojis lists
     */
    getOrgEmojiLists() {
        return this.WbHttpClient.get('emoji/getOrgEmojiLists');
    }
    /**
     * user add reacted emoji
     */
    addReactedEmoji(params) {
        return this.WbHttpClient.post('emoji/addReactedEmoji', params);
    }

    /**
     * user remove reacted emoji
     */
    removeReactedEmoji(params) {
        return this.WbHttpClient.post('emoji/removeReactedEmoji', params);
    }
}